import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TotalShipTableComponent } from './total-ship-table.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CustomCheckboxdropdownModule } from 'src/app/shared/components/custom-checkboxdropdown/custom-checkboxdropdown.module';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { TotalShipTableRoutingModule } from './total-ship-table-routing.module';
import { ChSkeletonComponent } from '../shared/ch-skeleton/ch-skeleton.component';



@NgModule({
  declarations: [
    TotalShipTableComponent
  ],
  imports: [
    CommonModule,
     MaterialModule,  
            FormsModule,
            CustomCheckboxdropdownModule,
                ReactiveFormsModule,
                CustomDropdownModule,
                CustomDatePickerModule,
                MaterialModule,
                CustomTimpickerModule,
                CustomInputModule,
                MatPaginatorModule,
                TotalShipTableRoutingModule,
                ChSkeletonComponent
  ]
})
export class TotalShipTableModule { }
